<template>
  <div class="news_wrap">
    <div class="news_tit">新闻资讯</div>
    <div class="news_detail">
      <div class="news_cards">
        <div
            v-for="(item, index) in homeNewsItems"
            :key="index"
            class="news_item"
            @click="goNewsDetail(item)"
        >
          <div class="bottom_wrap">
            <div class="bottom_left">
              <div class="news_thumb_wrap">
                <img
                  class="news_thumb_img"
                  :src="item.img"
                  alt=""
                >
                <span
                  v-if="isWechatNews(item)"
                  class="news_source_badge"
                >转载</span>
              </div>
            </div>
            <div class="bottom_right">
              <div class="right_title">{{ item.title }}</div>
              <div class="right_body">
                <div class="right_desc">{{ introPreview(item.intro) }}</div>
                <div class="right_footer">
                  <span
                    v-if="isExternalNewsUrl(item.url)"
                    class="right_cta"
                  >查看原文</span>
                  <time
                    v-if="item.createTime"
                    class="right_date"
                  >{{ item.createTime }}</time>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="showNewsMoreBtn"
        class="news_more_row"
      >
        <router-link
            class="news_more_btn"
            to="/fournav/3"
        >查看更多
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mediaList,
  isExternalNewsUrl,
  isWechatNews,
  openNewsLink,
} from '@/utils/mediaList'
const HOME_NEWS_COUNT = 2
const INTRO_PREVIEW_MAX = 64

function introPreview (text) {
  if (!text) return ''
  const flat = String(text).replace(/\s+/g, ' ').trim()
  if (flat.length <= INTRO_PREVIEW_MAX) return flat
  return flat.slice(0, INTRO_PREVIEW_MAX) + '…'
}

export default {
  computed: {
    homeNewsItems () {
      return mediaList.slice(0, HOME_NEWS_COUNT)
    },
    /** 列表条数不超过首页展示条数时，无需「查看更多」 */
    showNewsMoreBtn () {
      return mediaList.length > HOME_NEWS_COUNT
    },
  },
  methods: {
    introPreview,
    isExternalNewsUrl,
    isWechatNews,
    goNewsDetail (item) {
      openNewsLink(item, this.$router)
    },
  },
}
</script>

<style lang="scss" scoped>
.news_wrap {
  width: 100%;
  margin-top: 50px;
  text-align: center;
  padding-bottom: 24px;

  .news_tit {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
  }

  .news_detail {
    width: 70%;
    margin: 40px auto 0;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
  }

  .news_cards {
    display: flex;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
  }

  .news_item {
    flex: 1;
    min-width: 280px;
    max-width: calc(50% - 12px);
    margin-top: 8px;
    cursor: pointer;
    text-align: left;
    padding: 16px 18px 20px;
    background: #fafbfc;
    border-radius: 8px;
    border: 1px solid #eef0f2;
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
      box-shadow: 0 6px 20px rgba(32, 48, 64, 0.08);
      border-color: #e0e4e8;
    }

    @media screen and (max-width: 768px) {
      max-width: 100%;
      padding: 12px 14px 16px;
    }

    .bottom_wrap {
      display: flex;
      @media screen and (max-width: 768px) {
        flex-direction: column;
      }

      .bottom_left {
        flex-shrink: 0;
      }

      .news_thumb_wrap {
        position: relative;
        display: inline-block;
        width: 220px;
        @media screen and (max-width: 768px) {
          width: 100%;
        }
      }

      /* 固定物理像素 + GPU 合成优化，减轻缩放糊边（样式不受 postcss 转 vw 影响时已排除本文件） */
      .news_thumb_img {
        width: 220px;
        height: 132px;
        object-fit: cover;
        object-position: center;
        border-radius: 6px;
        display: block;
        flex-shrink: 0;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
        transform: translateZ(0);

        @media screen and (max-width: 768px) {
          width: 100%;
          height: 148px;
        }
      }

      .news_source_badge {
        position: absolute;
        left: 8px;
        top: 8px;
        z-index: 1;
        padding: 2px 8px;
        font-size: 11px;
        font-weight: 500;
        line-height: 1.4;
        letter-spacing: 0.04em;
        color: #fff;
        background: rgba(32, 48, 64, 0.78);
        border-radius: 4px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.18);
        pointer-events: none;

        @media screen and (max-width: 768px) {
          left: 6px;
          top: 6px;
          padding: 3px 7px;
          font-size: 10px;
          line-height: 1.3;
          border-radius: 3px;
          background: rgba(32, 48, 64, 0.82);
        }
      }

      .bottom_right {
        margin-left: 16px;
        flex: 1;
        min-width: 0;

        @media screen and (max-width: 768px) {
          margin-left: 0;
          margin-top: 10px;
        }

        .right_title {
          font-weight: bold;
          font-size: 17px;
          color: #203040;
          line-height: 1.45;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
          @media screen and (max-width: 768px) {
            font-size: 1rem;
          }
        }

        .right_body {
          margin-top: 10px;
          height: calc(14px * 1.6 * 3);
          display: flex;
          flex-direction: column;
        }

        .right_desc {
          color: #717171;
          font-size: 14px;
          line-height: 1.6;
          overflow: hidden;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          text-overflow: ellipsis;
        }

        .right_footer {
          margin-top: auto;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 10px;
        }

        .right_cta {
          font-size: 12px;
          color: #2091d3;
          line-height: 1.4;
        }

        .right_date {
          font-size: 12px;
          line-height: 1.4;
          color: #909399;
          letter-spacing: 0.02em;
        }
      }
    }
  }

  .news_more_row {
    margin-top: 28px;
    text-align: center;
  }

  .news_more_btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 160px;
    padding: 10px 28px;
    background: #ffa400;
    font-size: 15px;
    color: #fff;
    border-radius: 24px;
    text-decoration: none;
    font-weight: 500;
    box-shadow: 0 2px 8px rgba(255, 164, 0, 0.35);
    transition: background 0.2s, transform 0.15s;

    &:hover {
      background: #e89500;
      color: #fff;
      transform: translateY(-1px);
    }

    @media screen and (max-width: 768px) {
      min-width: 140px;
      padding: 8px 22px;
      font-size: 14px;
    }
  }
}
</style>
